import React from 'react'
import { useNavigate } from 'react-router-dom'
import Icon from '../../components/Icon/Icon'
import './Legal.scss'

function LegalNotice() {
    const navigate = useNavigate()

    const handleGoBack = () => {
        if (window.history.length > 1) {
            navigate(-1)
        } else {
            navigate('/')
        }
    }

    return (
        <div className="legal-wrapper">
            <div className="legal-nav-container">
                <div className="legal-nav-inner">
                    <button 
                        className="legal-nav-back" 
                        onClick={handleGoBack}
                        aria-label="Go back"
                        tabIndex={0}
                        onKeyDown={(e) => e.key === 'Enter' && handleGoBack()}
                    >
                        <Icon alias="chevron-left" stroke="#0A0F1E" color="#0A0F1E" width={24} />
                    </button>
                    <h1 className="legal-nav-title">Mentions légales</h1>
                </div>
            </div>

            <div className="legal-container">
                <section className="legal-section">
                    <h2>HYK MEDIA</h2>
                    <p>Société par actions simplifiée au capital social de 1 000,00 euros</p>
                    <p>Immatriculée au Registre du Commerce et des Sociétés de Paris sous le numéro 928 546 142</p>
                    <p>Dont le siège social est situé 38, rue des Saints-Pères, 75007, Paris</p>
                    <p>Représentée par son Président, Monsieur Abdallah Slaiman</p>
                    <p>Contact : <a href="mailto:connect@hyk.media">connect@hyk.media</a></p>
                </section>

                <section className="legal-section">
                    <h2>Hébergeur du site</h2>
                    <p><strong>Nom et raison sociale :</strong> [à compléter]</p>
                    <p><strong>Adresse :</strong> [à compléter]</p>
                    <p><strong>Contact :</strong> [à compléter, en ce compris un numéro de téléphone]</p>
                </section>
            </div>
        </div>
    )
}

export default LegalNotice
